/* Copyright (c) 2022 Xperi. All Rights Reserved.  */

import React, { FunctionComponent, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { SelectOptionProps } from './SelectOptionProps';
import { RootState } from '../../../../../store/root.reducers';
import { setOverlayHighlightHorizontalLimitAction } from '../../../../../store/overlay/overlayhighlight/overlayhighlight.actions';
import { Mousetrap } from '../../../../common';

import leftArrow from '../../../../../assets/images/hydra_icon_scrolling_pill_arrow_left.png';
import rightArrow from '../../../../../assets/images/hydra_icon_scrolling_pill_arrow_right.png';

import './SelectOption.scss';

const SelectOption: FunctionComponent<SelectOptionProps> = (props): JSX.Element => {
    const { horizontalPosition } = useSelector((state: RootState) => state.overlayHighlight);
    const { text, options, isFocused, id } = props;
    const { isOverlayGhostHighlightActive, verticalPosition } = useSelector(
        (state: RootState) => state.overlayHighlight,
    );

    const dispatch = useDispatch();

    useEffect(() => {
        if (options?.length) {
            dispatch(setOverlayHighlightHorizontalLimitAction(options.length));
        }
        return () => {
            dispatch(setOverlayHighlightHorizontalLimitAction(0));
        };
    }, [options]);
    return (
        <div className="select-option-container">
            <div className="select-option-text">{text}</div>
            {isOverlayGhostHighlightActive ? (
                <Mousetrap value={id}>
                    <div
                        className={`select-button ${
                            id === verticalPosition ? 'highlight-button ghost-overlay' : ''
                        }`}
                    >
                        <img className="select-option-left-arrow" src={leftArrow}></img>
                        <div className="select-option-name">{options[horizontalPosition]}</div>
                        <img className="select-option-right-arrow" src={rightArrow}></img>
                    </div>
                </Mousetrap>
            ) : (
                <Mousetrap value={id}>
                    <div className={`select-button ${isFocused ? 'highlight-button' : ''}`}>
                        <img className="select-option-left-arrow" src={leftArrow}></img>
                        <div className="select-option-name">{options[horizontalPosition]}</div>
                        <img className="select-option-right-arrow" src={rightArrow}></img>
                    </div>
                </Mousetrap>
            )}
        </div>
    );
};

SelectOption.propTypes = {
    options: PropTypes.array.isRequired,
    isFocused: PropTypes.bool.isRequired,
    text: PropTypes.string.isRequired,
    id: PropTypes.number,
};

export default SelectOption;
